import styled from "styled-components";
import { ShapeEditor } from "react-shape-editor";

export const HtmlShapeEditor = styled(ShapeEditor)`
    position: absolute;
    top: 0;
    left: 0;
`;
